import ldfSeriesState from './ldfSeriesState';
import externalHandlers from './external';
import internalHandlers from './internal';
import legacyHandlers from './legacy';

const handlers = [...ldfSeriesState, ...externalHandlers, ...internalHandlers, ...legacyHandlers];

export default handlers;
